import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgIndent = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 18.25C21.5523 18.25 22 18.6977 22 19.25V19.75C22 20.3023 21.5523 20.75 21 20.75H3C2.44772 20.75 2 20.3023 2 19.75V19.25C2 18.6977 2.44772 18.25 3 18.25H21ZM2 10.25C2 9.42595 2.94076 8.95557 3.6 9.45L5.93333 11.2C6.46667 11.6 6.46667 12.4 5.93333 12.8L3.6 14.55C2.94076 15.0444 2 14.574 2 13.75V10.25ZM21 13.25C21.5523 13.25 22 13.6977 22 14.25V14.75C22 15.3023 21.5523 15.75 21 15.75H10.5C9.94772 15.75 9.5 15.3023 9.5 14.75V14.25C9.5 13.6977 9.94772 13.25 10.5 13.25H21ZM21 8.25C21.5523 8.25 22 8.69772 22 9.25V9.75C22 10.3023 21.5523 10.75 21 10.75H10.5C9.94772 10.75 9.5 10.3023 9.5 9.75V9.25C9.5 8.69772 9.94772 8.25 10.5 8.25H21ZM21 3.25C21.5523 3.25 22 3.69772 22 4.25V4.75C22 5.30228 21.5523 5.75 21 5.75H3C2.44772 5.75 2 5.30228 2 4.75V4.25C2 3.69772 2.44772 3.25 3 3.25H21Z", fill: props.fill }));
});
export default SvgIndent;
